import { Injectable, inject } from '@angular/core';
import { PressureMonitoringConfiguration, PressureSensor, PressureService, TenantService } from '@api';
import { Action, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { TENANT_ID } from '../../../authorization/authorization-factories';
import { AssetInfo } from './models/asset-info';
import { GetConfiguration, GetPressureSensors, SaveConfiguration, SetSelectedAsset } from './pressure.actions';

export interface IPressureState {
    pressureSensors: PressureSensor[];
    configuration: PressureMonitoringConfiguration;
    selectedAsset: AssetInfo;
}

@State<IPressureState>({
    name: 'pressure',
    defaults: {
        pressureSensors: [],
        configuration: null,
        selectedAsset: null,
    },
})
@Injectable({ providedIn: 'root' })
export class PressureState {
    private pressureService = inject(PressureService);
    private tenantService = inject(TenantService);
    private tenantId = inject(TENANT_ID);

    @Action(GetConfiguration)
    public getThirdPartyAppConfiguration({ patchState }: StateContext<IPressureState>, actions: GetConfiguration) {
        return this.tenantService.getThirdPartyAppConfiguration(actions.appName, this.tenantId).pipe(
            tap((configuration: PressureMonitoringConfiguration) => {
                patchState({ configuration });
            })
        );
    }

    @Action(SaveConfiguration)
    public saveThirdPartyAppConfiguration(_: StateContext<IPressureState>, actions: SaveConfiguration) {
        return this.tenantService.updateThirdPartyAppConfiguration(this.tenantId, actions.configuration);
    }

    @Action(GetPressureSensors)
    public getPressureSensors({ patchState }: StateContext<IPressureState>) {
        return this.pressureService.getPressureSensors(this.tenantId).pipe(
            tap((pressureSensors: PressureSensor[]) => {
                patchState({ pressureSensors });
            })
        );
    }

    @Action(SetSelectedAsset)
    public setSelectedAsset({ patchState }: StateContext<IPressureState>, actions: SetSelectedAsset) {
        patchState({ selectedAsset: actions.selectedAsset });
    }
}
